import { Center, Group, Paper, RingProgress, SimpleGrid, Text } from '@mantine/core';
import * as icons from '@sloyd/icons';

const defaultData = [
  { label: 'Credits', stats: '195', progress: 65, color: 'violet.6', icon: 'IconArrowUpRight' },
  {
    label: 'GLB Exports',
    stats: '2,550',
    progress: 72,
    color: 'blue.6',
    icon: 'IconArrowDownRight',
  },
  {
    label: 'Animations',
    stats: '123',
    progress: 52,
    color: 'green.6',
    icon: 'IconArrowUpRight',
  },
] as const;

export type StatsProps = {
  data: Json[];
};

export function Stats(props: StatsProps) {
  const { data = defaultData } = props;

  const stats = data.map((stat) => {
    const Icon = (icons as any)[stat.icon];

    return (
      <Paper withBorder radius='md' p='xs' key={stat.label}>
        <Group>
          <RingProgress
            size={80}
            roundCaps
            thickness={8}
            sections={[{ value: stat.progress, color: stat.color }]}
            label={<Center>{Icon && <Icon size={20} stroke={1.5} />}</Center>}
          />

          <div>
            <Text c='dimmed' size='xs' tt='uppercase' fw={700}>
              {stat.label}
            </Text>
            <Text fw={700} size='xl'>
              {stat.stats}
            </Text>
          </div>
        </Group>
      </Paper>
    );
  });

  return <SimpleGrid cols={{ base: 1, sm: 3 }}>{stats}</SimpleGrid>;
}
